class VariantInventoryStates {
  constructor() {
    this.productData = null;
    this.currentSelections = {};
    this.observer = null;
    
    this.init();
  }
  
  init() {
    const productJsonElement = document.querySelector('[data-product-json]');
    if (!productJsonElement) return;
    
    try {
      this.productData = JSON.parse(productJsonElement.textContent);
    } catch (e) {
      console.error('Failed to parse product JSON:', e);
      return;
    }
    
    this.readCurrentSelections();
    this.updateAllOptionStates();
    
    setTimeout(() => {
      this.updateAllOptionStates();
    }, 100);
    
    setTimeout(() => {
      this.updateAllOptionStates();
    }, 300);
    
    setTimeout(() => {
      this.updateAllOptionStates();
    }, 500);
    
    this.startWatchingForDisabledClass();
    
    document.body.addEventListener('click', (e) => {
      const label = e.target.closest('.variant-option-label');
      const input = e.target.closest('input[data-option-name]');
      
      if (label && label.dataset.optionName && label.dataset.optionValue) {
        setTimeout(() => {
          this.readCurrentSelections();
          this.updateAllOptionStates();
          setTimeout(() => {
            this.updateAllOptionStates();
          }, 100);
        }, 150);
      } else if (input && input.dataset.optionName) {
        setTimeout(() => {
          this.readCurrentSelections();
          this.updateAllOptionStates();
          setTimeout(() => {
            this.updateAllOptionStates();
          }, 100);
        }, 150);
      }
    }, true);
    
    document.body.addEventListener('change', (e) => {
      const input = e.target.closest('input[data-option-name]');
      if (input && input.dataset.optionName) {
        setTimeout(() => {
          this.readCurrentSelections();
          this.updateAllOptionStates();
          setTimeout(() => {
            this.updateAllOptionStates();
          }, 100);
        }, 150);
      }
    }, true);
  }
  
  startWatchingForDisabledClass() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;
    
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const input = mutation.target;
          if (input.classList.contains('disabled') && !input.checked) {
            input.classList.remove('disabled');
          }
        }
      });
    });
    
    this.observer.observe(variantSelects, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }
  
  readCurrentSelections() {
    this.currentSelections = {};
    const inputs = document.querySelectorAll('input[data-option-name][data-option-value]:checked');
    inputs.forEach(input => {
      this.currentSelections[input.dataset.optionName] = input.dataset.optionValue;
    });
  }
  
  updateAllOptionStates() {
    const labels = document.querySelectorAll('.variant-option-label[data-option-name][data-option-value]');
    
    const optionGroups = {};
    labels.forEach(label => {
      const optionName = label.dataset.optionName;
      if (!optionGroups[optionName]) {
        optionGroups[optionName] = [];
      }
      optionGroups[optionName].push(label);
    });
    
    Object.keys(optionGroups).forEach(optionName => {
      optionGroups[optionName].forEach(label => {
        this.updateOptionState(label, optionName);
      });
    });
  }
  
  updateOptionState(label, optionName) {
    const optionValue = label.dataset.optionValue;
    
    const inputSelector = 'input[data-option-name="' + optionName + '"][data-option-value="' + optionValue + '"]';
    const input = document.querySelector(inputSelector);
    
    const otherSelections = {};
    Object.keys(this.currentSelections).forEach(key => {
      if (key !== optionName) {
        otherSelections[key] = this.currentSelections[key];
      }
    });
    
    const matchingVariants = this.productData.variants.filter(variant => {
      if (variant.options[optionName] !== optionValue) {
        return false;
      }
      
      return Object.keys(otherSelections).every(key => {
        return variant.options[key] === otherSelections[key];
      });
    });
    
    const hasInStock = matchingVariants.some(v => v.available && v.inventory_quantity > 0);
    const hasContinueSelling = matchingVariants.some(v => 
      v.inventory_quantity <= 0 && v.inventory_policy === 'continue'
    );
    const hasUnavailable = matchingVariants.some(v => 
      !v.available || (v.inventory_quantity <= 0 && v.inventory_policy !== 'continue')
    );
    
    label.classList.remove('variant-option--unavailable', 'variant-option--continue-selling');
    
    if (input && !input.checked) {
      input.classList.remove('disabled');
      label.style.pointerEvents = '';
    }
    
    if (hasContinueSelling && !hasInStock) {
      label.classList.add('variant-option--continue-selling');
    } else if (!hasInStock && hasUnavailable) {
      label.classList.add('variant-option--unavailable');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new VariantInventoryStates();
  });
} else {
  new VariantInventoryStates();
}
